// @ts-nocheck

import { css } from 'styled-components';

const LibStyle = css`
  a {
    color: unset;
    text-decoration: none;
    -webkit-tap-highlight-color: transparent;
  }
`;

export default LibStyle;
